"use strict";

/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
module.exports = /*@ngInject*/function ($rootScope, Idle, $uibModal, IDLE_TIMEOUT_WARNING) {
  var ctrl = this;
  ctrl.data = 'Idle Timeout';
  // eslint-disable-next-line no-unused-expressions, dot-notation, no-undef
  window['aws_amplify'];
  ctrl.closeModals = function () {
    if ($rootScope.warning) {
      $rootScope.warning.close();
      $rootScope.warning = null;
    }
  };
  return {
    setUpTimeout: function setUpTimeout(signOut) {
      $rootScope.$on('IdleStart', function () {
        $rootScope.warning = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'activity-manager/warning-dialog.html',
          backdrop: 'static',
          // eslint-disable-next-line object-shorthand
          controller: /*@ngInject*/function controller(data) {
            var $ctrl = this;
            $ctrl.title = data;
            $ctrl.countdownTimer = IDLE_TIMEOUT_WARNING;
            $ctrl.signOut = function () {
              signOut();
            };
            $ctrl.stayOn = function () {
              ctrl.closeModals();
            };
          },
          controllerAs: '$ctrl',
          size: 'sm',
          resolve: {
            data: function data() {
              return ctrl.data;
            }
          }
        });
      });
      $rootScope.$on('IdleTimeout', function () {
        signOut();
      });
    }
  };
};